import React, { useEffect } from "react"
import Navbar from "../../components/admin/Navbar.tsx";
import MenuComponent from "../../components/admin/MenuComponent.tsx";

/**
 * Represents the home page of the application.
 * It includes a navigation bar, a navigation section, sports schedule, and a schedule table.
 * @returns JSX elements representing the home page layout.
 */
const LayoutAdmin = () => {

    useEffect(() => {
        document.body.classList.add("admin-body");
        return () => {
            document.body.classList.remove("admin-body");
        };
    }, []);

    useEffect(() => {
        const scroll = () => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTo(0, 0);
            document.body.scrollTo(0, 0);
            const root = document.getElementById('root');
            if (root) root.scrollTo(0, 0);
        };
        scroll();
        requestAnimationFrame(scroll);
        const t = setTimeout(scroll, 100);
        return () => clearTimeout(t);
    }, []);


    return (

        <>
            <Navbar />
            <div className='container-fluid admin-shell'>
                <div className='row'>
                    <div className='col-lg-12 col-xs-12'>
                        <MenuComponent />
                    </div>
                </div>
            </div>
        </>
    );
}
export default LayoutAdmin ;